import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box } from '@chakra-ui/react';
import { LogoHubSimple, LogoZipSimple, PremierInnLogo } from '../assets/icons';
import Icon from '../components/Icon';
import { jsx as _jsx } from "react/jsx-runtime";
export function getLogoByBrand(brand, code) {
  var logoStyle = {
    position: 'relative',
    transform: 'scale(0.45)'
  };
  var iconStyle = {
    width: 'var(--chakra-space-lg)',
    height: 'var(--chakra-space-lg)',
    marginRight: 'var(--chakra-space-md)'
  };
  if (brand === 'PI' || brand === 'PID') {
    return _jsx(Box, {
      mr: "md",
      style: {
        position: 'relative',
        top: '-0.125rem'
      },
      children: _jsx(PremierInnLogo, {})
    }, code);
  }
  if (brand === 'HUB') {
    return _jsx(Icon, {
      style: iconStyle,
      svg: _jsx(LogoHubSimple, {
        style: _objectSpread(_objectSpread({}, logoStyle), {}, {
          top: '-1.25rem',
          left: '-1.125rem'
        })
      })
    }, code);
  }
  if (brand === 'ZIP') {
    return _jsx(Icon, {
      style: iconStyle,
      svg: _jsx(LogoZipSimple, {
        style: _objectSpread(_objectSpread({}, logoStyle), {}, {
          top: '-0.375rem',
          left: '-1.5rem'
        })
      })
    }, code);
  }
}